import { Helpers } from '../../helpers';
import { IConstraintFacilityConstrainedSchedule } from '../../interfaces/iconstraint-facility-constrained-schedule';
import { AreaType } from '../area-type';
import { ConstraintFacilityConstrainedScheduleDetail } from '../constraint-facility-constrained-schedule-detail';
import { Scenario } from '../scenario';

export class ConstraintFacilityConstrainedScheduleBase {
  ConstraintFacilityConstrainedScheduleId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintFacilityConstrainedScheduleDetails_ConstraintFacilityConstrainedSchedule?: Array<ConstraintFacilityConstrainedScheduleDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintFacilityConstrainedSchedule) {
    if (item) {

      this.ConstraintFacilityConstrainedScheduleId = item.ConstraintFacilityConstrainedScheduleId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintFacilityConstrainedScheduleDetails_ConstraintFacilityConstrainedSchedule = Helpers.createClassArray(ConstraintFacilityConstrainedScheduleDetail, item.ConstraintFacilityConstrainedScheduleDetails_ConstraintFacilityConstrainedSchedule);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}